import { render, staticRenderFns } from "./activityInformation.vue?vue&type=template&id=84c599c8&scoped=true"
import script from "./activityInformation.vue?vue&type=script&lang=js"
export * from "./activityInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c599c8",
  null
  
)

export default component.exports